/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import { isError } from "@epic-mw/error-types";
import useSWRImmutable from "swr/immutable";

import { getApiPath } from "../utils";

const defaultLaunchDarklyFlagValues = {
	"epicgames-use-cosmos": true,
};

export const getFlag = async <T extends keyof typeof defaultLaunchDarklyFlagValues>(
	flag: T,
): Promise<(typeof defaultLaunchDarklyFlagValues)[T]> => {
	let flags = (window as any)._epicFlags as typeof defaultLaunchDarklyFlagValues | undefined;

	if (!flags) {
		try {
			const response = await fetch(`${getApiPath()}/launch-darkly-flags`);
			flags = await response.json();
		} catch (err) {
			console.error("flags() failed to load", isError(err) && err.message);
		}
	}

	if (!flags) {
		return defaultLaunchDarklyFlagValues[flag];
	}
	return flags[flag];
};

export const useFlag = <T extends keyof typeof defaultLaunchDarklyFlagValues>(
	flag: T,
): {
	value?: (typeof defaultLaunchDarklyFlagValues)[T];
	isLoading: boolean;
	error?: string;
} => {
	const { data, error } = useSWRImmutable(`flags-${flag}`, () => getFlag(flag), {
		errorRetryCount: 1,
	});

	return {
		value: data,
		isLoading: !data && !error,
		error,
	};
};
